export const changeLanguage = (store, route, lang) => {
  store.state.language = lang;

  route.query.locale = lang;
  history.pushState({}, null, route.path + "?locale=" + lang);
};
